import { useState } from 'react';
import { useDataProvider, useNotify, useRefresh, useRecordContext } from 'react-admin';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography, IconButton } from '@mui/material';
import { formatDate } from './clientSplitHelpers';
import DeleteIcon from '@mui/icons-material/Delete';
import { Tooltip } from '@mui/material';

const DeactivateRuleButton = () => {
  const record = useRecordContext();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();

  const [open, setOpen] = useState(false);

  if (!record) return null;

  const handleDeactivate = async () => {
    try {
      const res = await dataProvider.create('DeactivateClientSplitRule', {
        data: { rule_id: record.rule_id },
      });

      if (res.data.success) {
        notify('notifications.TPA_TRANSITION.DEACTIVATE.SUCCESS', { type: 'success' });
        refresh();
      } else {
        notify('notifications.TPA_TRANSITION.DEACTIVATE.SUCCESS', { type: 'success' });
        refresh();
      }

      setOpen(false);
    } catch (e: any) {
      notify('notifications.TPA_TRANSITION.DEACTIVATE.FAILED_OR_ALREADY_INACTIVE', { type: 'error' });
      setOpen(false);
    }
  };

  return (
    <>
      <Tooltip title="Delete rule">
        <IconButton color="primary" onClick={() => setOpen(true)} sx={{ mx: 'auto', display: 'flex' }}>
          <DeleteIcon />
        </IconButton>
      </Tooltip>

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Deactivate Rule</DialogTitle>

        <DialogContent dividers>
          <Typography gutterBottom>Are you sure you want to deactivate this rule?</Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
            <strong>Client:</strong> {record.client_name} ({record.client_number})
          </Typography>

          <Typography variant="body2">
            <strong>Split Type:</strong> {record.split_type}
          </Typography>

          <Typography variant="body2">
            <strong>Billing Client:</strong> {record.billing_client_name} ({record.billing_client_number})
          </Typography>

          <Typography variant="body2">
            <strong>Effective Start:</strong> {formatDate(record.effective_start_dt)}
          </Typography>

          <Typography variant="body2">
            <strong>Created Date:</strong> {formatDate(record.created_dt)}
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button color="error" variant="contained" onClick={handleDeactivate}>
            Deactivate
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeactivateRuleButton;
